import type {
  CoreQuoteRequestParams,
  GetQuotesParams,
  GetQuotesResponse,
  GetSavedQuotesParams,
  SavedQuotesResponse,
  SaveQuotesRequest,
  SaveQuotesResponse,
  ValidatePromoCodeParams,
  ValidatePromoCodeResponse,
} from '@/entities/Quote/model/Quote.types';
import { BaseService, defineApi } from '@/shared/api';
import { filterEmptyValue } from '@/shared/utils';

class QuoteService extends BaseService {
  async validatePromoCode({
    promoCode,
    isUpgrade,
  }: ValidatePromoCodeParams): Promise<ValidatePromoCodeResponse> {
    return await this.post('/validate-promocode', { promoCode, isUpgrade });
  }

  async saveQuotes(payload: SaveQuotesRequest): Promise<SaveQuotesResponse> {
    return await this.post('/save-quotes', payload);
  }

  async getQuotes(params: GetQuotesParams, abortSignal?: AbortSignal): Promise<GetQuotesResponse> {
    const cleanParams = filterEmptyValue(params);
    return await this.post('/quotes', cleanParams, { signal: abortSignal });
  };

  async postQuotes(payload: CoreQuoteRequestParams): Promise<GetQuotesResponse> {
    return await this.post('/quotes', payload);
  };

  async getSavedQuotes(params: GetSavedQuotesParams): Promise<SavedQuotesResponse> {
    return await this.get('/saved-quotes', { params });
  }
}
export const useQuoteService = defineApi(QuoteService, { version: 'v3' });
